<template>
<div>
    <div class="panel">
        <div class="panel-heading">
            <div class="panel-label">
                <h3 v-if="!neverEdit">Products </h3><br/>
            </div>
        </div>
        <div class="panel-heading">
            <div class="panel-label">
                <h4>WARNING: Table below will be products data for all selected shops to bulk update.</h4>
            </div>
        </div>
        <div class="panel-body">
            <vue-table ref="table" :useSearch="true"
                        v-if="!loadingState"
                        :dataTable="defaultProductsTable"
                        :defaultSortOrder="[getProductsTableSortOrder]"
                        :tableFields="TableFields"
                        @sortUpdate="sortUpdate"
                        :slots="slots"
                        :perPage="perPage"
                        class="products-table">

                <template slot="name" slot-scope="props">
                    <div class="names">
                        <!--<span class="display-names" v-for="format in props.data.formats" :key="format.displayName">{{format.displayString}}</span>-->
                        <span v-if="!edit">{{props.data.formats[0].displayString}}</span>
                        <input class="test-input" v-if="edit" v-model="props.data.formats[0].displayString" type="string" @focus="props.data.focused=true">
                    </div>
                </template>
                <template slot="price" slot-scope="props">
                    <span v-if="!edit">{{props.data.priceValue}}</span>
                    <input class="test-input" v-if="edit" v-model="props.data.priceValue" type="number" @focus="props.data.focused=true" @input="props.data.focused=true">
                </template>
                <template slot="order" slot-scope="props">
                    <span v-if="!edit">{{props.data.order}}</span>
                    <input class="test-input" v-if="edit" v-model="props.data.order" type="number" @focus="props.data.focused=true" @input="props.data.focused=true" @keypress="isNumber($event)">
                </template>
                <template slot="bundleSize" slot-scope="props">
                    {{props.data.bundleSize}}
                </template>
                <template slot="enable" slot-scope="props">
                    <span v-if="!edit">{{props.data.active ? 'on' : 'off' }}</span>
                    <div v-if="showToggler">
                        <vue-checkbox-toggle
                            v-if="edit"
                            ref="checkbox"
                            v-model="props.data.active"
                            @focus="props.data.focused=true"
                            :show-labels="false"
                            label-checked="on"
                            label-unchecked="off"
                        >
                        </vue-checkbox-toggle>
                    </div>
                </template>
                <template slot="codefield" slot-scope="props">
                    {{props.data.code !== 'undefined' ? props.data.code : '-'}}
                </template>
                <template slot="plu" slot-scope="props">
                    <span v-if="!edit">{{props.data.plu}}</span>
                    <input class="test-input" v-if="edit" v-model="props.data.plu" type="string" :maxlength="10"  @focus="props.data.focused=true">
                </template>
                <template slot="version" slot-scope="props">
                    <span v-if="!edit">{{props.data.version}}</span>
                    <input class="test-input" v-if="edit" v-model="props.data.version" type="string" :maxlength="10"  @focus="props.data.focused=true">
                </template>
                <template slot="actions" slot-scope="props">
                    <button v-if="edit" class="btn btn-sm btn-danger" v-on:click="addPromo(props)">Add promotion</button>
                </template>
            </vue-table>
        </div>
    </div>

    <functional-modal
            :showModal="showModal"
            title="Products bulk update"
            @close="showModal = false"
            :showClose="false"
            >
             <div :class="['col-12']" slot="body">
                 <h3>Are you want to update all shops?</h3>
                     <button class="btn btn-lg btn-danger mr-3" v-on:click="showModal = false; saveBulk(defaultProductsTable)">Confirm</button>
                     <button class="btn btn-lg btn-success" v-on:click="showModal = false">Cancel</button>
             </div>
    </functional-modal>
    <button v-if="bulk" class="btn btn-lg btn-danger" v-on:click="saveBulk(defaultProductsTable)">SAVE</button>

    <promotions-view-bulk
        @feeTableClicked="feeTableClicked"
        :orderFee="orderFee"
        @closeModal="closeModal"
        :edit="false"
        :formOpen="addPromotion"
        :selectedProduct="selectedProduct"
        v-on:close-form="closeModal"
        @saveMethod="save(allProducts, false)"
        @promotions="promotions"
        :showadd="showadd">
    </promotions-view-bulk>

</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions, mapMutations } from 'vuex';
import objectPath from 'object-path';
import Table from '../../../components/Panel/Table/Table';
import ShopsTableFields from '../../../utilities/tablesProperties/ShopsTableFields';
import VueCheckboxToggle from '../../../components/Shared/Toggler';
import _ from 'underscore';
import FunctionalModal from '../../../components/Shared/Modal/FunctionalModal.vue';
import PromotionsViewBulk from '../Promotions/PromotionsViewBulk.vue';

export default {
    name: 'productsBulkTable',
    components: {
        'vue-table': Table,
        VueCheckboxToggle,
        FunctionalModal,
        PromotionsViewBulk,
    },
    props: {
        id: {
            type: String,
            default: ''
        },
        fastedit: {
            type: String,
            default: ''
        },
        hideAddition: {
            type: Boolean,
            default: false
        },
        userTableView: {
            type: Boolean,
            default: false
        },
        neverEdit:{
            type: Boolean,
            default: false
        },
        perPage:{
            type: Number,
            default: 1000
        },
        applyToShops: {
            type: Array,
            default (){
                return [];
            }
        }
    },
    watch: {
        applyToShops (newVal) {
            this.bulk = newVal.length > 0;
        }
    },
    data () {
        return {
            bulk: true,
            selectedProduct: null,
            showToggler: false,
            edit: true,
            showPromotionView: true,
            slots: [
                {
                    name: 'name'
                },
                {
                    name: 'actions'
                },
                {
                    name: 'codefield'
                },
                {
                    name: 'enable'
                },
                {
                    name: 'price'
                },
                {
                    name: 'order'
                },
                {
                    name: 'plu'
                },
                {
                    name: 'bundleSize'
                },
                {
                    name: 'version'
                }
            ],
            TableFields: [
                {
                    name: 'name',
                    title: 'name',
                    sortField: 'formatDisplayString',
                    propName: 'formatDisplayString'
                },
                {
                    name: 'type',
                    title: 'Type',
                    sortField: 'type',
                    propName: 'type'
                },
                {
                    name: 'codefield',
                    title: 'code',
                    sortField: 'code',
                    propName: 'code'
                },
                {
                    name: 'bundleSize',
                    title: 'bundleSize',
                    sortField: 'bundleSize',
                    propName: 'bundleSize'
                },
                {
                    name: 'price',
                    title: 'price',
                    sortField: 'priceValue',
                    propName: 'priceValue'
                },
                {
                    name: 'order',
                    title: 'order',
                    sortField: 'orderValue',
                    propName: 'orderValue'
                },
                {
                    name: 'plu',
                    title: 'plu',
                    sortField: 'plu',
                    propName: 'plu'
                },
                {
                    name: 'enable',
                    title: 'enable',
                    sortField: 'active',
                    propName: 'active'
                },
                {
                    name: 'version',
                    title: 'version',
                    sortField: 'active',
                    propName: 'active'
                },
                {
                    name: 'actions',
                    title: 'Actions',
                }
            ],
            buttons: {
                'show':{
                    name: 'show',
                    path: '/{{id}}',
                    icon: 'show'
                }
            },
            updateCounter: 0,
            showModal: false,
            defaultProductsTable: [],

            orderFee: null,
            addPromotion: false,
            showadd: false,
            selectedPromotions: []

        };
    },
    computed: {
        ...mapGetters({
            defaultProducts: 'getDefaultProducts',
            getProductsTableFilters: 'getProductsTableFilters',
            getProductsTableSortOrder: 'getProductsTableSortOrder',
            getProductsIncludingFilters: 'getProductsIncludingFilters',
            formats: 'getFormats',
            prices: 'getAllPrices',
            loadingState: 'getLoadingState',
            activeShop: 'getActiveShop',
        })
    },
    methods: {
        ...mapMutations([
            'updateProductGroupList',
            'updateLoadingState',
            'updateProducts',
            'addAlert',
            'updateUserShopList',
            'addFee'
        ]),
        ...mapActions([
            'AddProductsTableFilters',
            'SetProductsIncludingFilters',
            'loadProductsList',
            'loadProducts',
            'loadProduct',
            'productsSaved',
            'setContext',
            'setFee',
            'getProductDefaultAsync',
            'getProductDefaultListAsync',
            'setProductsBulkAsync',
        ]),
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode === 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async update (id) {
            this.defaultProductsTable = await this.getProductDefaultListAsync();
            this.updateLoadingState(false);
        },
        linkGen(path, id){
            return `/panel/shops${path.replace('{{id}}',id)}`;
        },
        async saveBulk(defaultProducts, reload = true ){
            let toSave = defaultProducts;

            const clonedProducts = [...this.defaultProductsTable]
            let refreshBackup = []
            await this.setProductsBulkAsync({shops: this.applyToShops, products: defaultProducts, promotions: this.selectedPromotions})
            this.$router.push({ name: 'Shops'});
        },
        sortUpdate () {
            this.showToggler = false;
            if(!this.showToggler) {
                this.$nextTick(() => {
                    this.showToggler = true;
                });
            }
        },
        runEdit (props){
            this.edit = true;
        },
        addPromo(props){
            this.addPromotion = true;
            this.showadd = true;
            this.selectedProduct = props.data;
        },
        feeTableClicked(data) {
            this.addFeeModal = true;
            this.editFee = data;
        },
        closeModal(){
            this.addPromotion = false;
            this.showadd = false;
        },
        promotions(promotions){
            this.selectedPromotions = promotions
        }
    },
    updated () {
        console.log("updated", this);
    },
    async created () {
        console.log("created ProductsBulkTable this", this);
        if(!this.fastedit) {
            this.updateCounter = 2;
        }

        if(this.applyToShops.length > 0){
            this.bulk = true;
        }
        this.defaultProductsTable = await this.getProductDefaultListAsync();
        this.updateLoadingState(false);
      //  this.setContext(this.$props.id);
        // this.update(this.id).then(() => {
        //     this.updateCounter++;
        // });
        //this.$store.dispatch('SetActiveShopAction', 'default-config');
    }
};

</script>

<style lang="scss" scoped>
    .panel
    {
        position: relative;
    }
    .container {
        margin-top: 50px;
    }

    .test-input{
        max-width: 100px;
    }

    .select-product {
        display: flex;
        flex-direction: column;
        padding-bottom: 0;
    }
    .preloader
    {
        pointer-events: none;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        background: #ffffff;
        z-index: 2;
        transition: opacity 700ms ease;

        &.active
        {
            pointer-events: all;
            opacity: 1;
        }
    }

    .modal-title {
        color: black;
    }

</style>
